import { ItemPrerolls, LogLevel } from '@utils'
import { logJSError } from '../../../../util/csm/csm'

export function fireDraperTrackingEvent(prerolls: ItemPrerolls, eventName: string) {
  const eventUrl = prerolls &&
    prerolls.trackingEvents &&
    prerolls.trackingEvents[eventName]
  
  if (window && window.location.href.includes('draperDebug')) {
    window.console.log({eventLogged: eventName, trackingEventURL: eventUrl, videoURL: prerolls.mediaFile})
  }

  if (eventUrl) {
    // not using APIClient here, as the CORS settings of the Draper endpoints
    // prohibit using {credentials: include}
    fetch(eventUrl).catch((err) => {
        logError('Error firing Draper tracking event', err)
    })
  }
}

export function logError(string: string, err: Error) {
  logJSError(err, {
    logLevel: LogLevel.ERROR,
    message: string,
    attribution: 'DVWebNodeDraperPlayer'
  })
}